import { FormField, Select, SelectOption } from "@justworkshr/milo-form";
import { ChangeEvent, ReactElement, useContext } from "react";
import { useFormikContext } from "formik";
import { AdditionalPayContext } from "pages/employer-of-record/payments/contexts/additionalPayContext";
import { SupportedCountriesContext } from "pages/employer-of-record/contexts/supportedCountriesContext";
import { useMemberData } from "pages/employer-of-record/payments/contexts/memberDataContext";
import { AdditionalPayFormData, FormPayloadType } from "../../types";
import styles from "../../Setup.module.css";
import {
  CountryCode,
  countriesWithSubdivisions,
} from "pages/employer-of-record/onboarding/constants";

function SubdivisionSelect(): ReactElement | null {
  const additionalPayContext = useContext(AdditionalPayContext);
  const { getSupportedProvinces } = useContext(SupportedCountriesContext);
  const memberDataContext = useMemberData();
  const { handleChange, values } =
    useFormikContext<AdditionalPayFormData<FormPayloadType>>();

  const workCountry = values.setUp.workCountry;
  const memberBySubdivisionCount =
    memberDataContext?.memberSubdivisionCount || {};

  if (
    !workCountry ||
    !(countriesWithSubdivisions as readonly CountryCode[]).includes(
      workCountry as CountryCode
    )
  ) {
    return null;
  }

  const subdivisions = getSupportedProvinces(workCountry);

  if (subdivisions.length === 0) return null;

  const onChangeHandler = (event: ChangeEvent<HTMLSelectElement>) => {
    handleChange(event);
    additionalPayContext?.setSelectedSubdivision(event.target.value);
  };

  return (
    <div className={styles.subdivisionSelect}>
      <FormField label="Work subdivision" name="setUp.workSubdivision">
        <Select
          name="setUp.workSubdivision"
          placeholder="Select"
          value={values.setUp.workSubdivision ?? ""}
          onChange={onChangeHandler}
          disabled={additionalPayContext?.isEdit}
        >
          {subdivisions.map((subdivision) => {
            const count = memberBySubdivisionCount[subdivision.code] || 0;
            return (
              <SelectOption
                value={subdivision.code}
                key={subdivision.code}
                disabled={count === 0}
              >
                {`${subdivision.name} (${count} members)`}
              </SelectOption>
            );
          })}
        </Select>
      </FormField>
    </div>
  );
}

export default SubdivisionSelect;
